import BookForm from "components/shared/book/form";
import { serializeReq } from "helpers/form";
import React, { lazy, Suspense } from "react";
import { config, initialState } from "../formConfig";

const Editor = lazy(() => import("components/shared/editor.js"));

class FormPopupTemplates extends BookForm {
    renderBody = () => {
        const { config } = this.props;
        const { text, organizationIds } = this.state;
        return (
            <>
                {this.renderField(config.header)}
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={text} onChange={(value) => this.setValue({ name: "text", value })} />
                </Suspense>
                {this.renderCheckbox(config.noWayToClose)}
                {this.renderCheckbox(config.forWhiteListOrganizations)}
                {this.renderField(config.countOfExpiredDays)}
                {this.renderField(config.daysBeforeSubscriptionExpires)}
                {this.renderField(config.daysUntilBlocking)}
                {this.renderSelect(config.moduleType)}
                {this.renderSelect(config.organizationIds)}
                {this.renderSelect({ ...config.roles, disabled: !organizationIds?.length })}
            </>
        );
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                delete state.files;
                return this.applyReq(serializeReq(state));
            }
            this.setState({ isValid: false });
        }
    };
}

const ConfiguredForm = (props) => <FormPopupTemplates {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
